import { useState, useCallback } from 'react';
import { Airport } from '../data/locations';

interface TooltipContent {
  airport: Airport;
  x: number;
  y: number;
}

/**
 * Custom hook to manage map tooltip state and positioning
 */
export function useMapTooltip() {
  const [tooltipContent, setTooltipContent] = useState<TooltipContent | null>(null);

  const handleMarkerMouseEnter = useCallback((airport: Airport, e: any) => {
    // Find the SVG element to get proper coordinates
    const svgElement = e.target.closest('svg');
    if (!svgElement) return;
    
    const rect = svgElement.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    setTooltipContent({ airport, x, y });
  }, []);

  const handleMarkerMouseLeave = useCallback(() => {
    setTooltipContent(null);
  }, []);

  return {
    tooltipContent,
    handleMarkerMouseEnter,
    handleMarkerMouseLeave
  };
}